import { render, staticRenderFns } from "./AuthorizedSection.vue?vue&type=template&id=4a36a331&scoped=true"
import script from "./AuthorizedSection.vue?vue&type=script&lang=js"
export * from "./AuthorizedSection.vue?vue&type=script&lang=js"
import style0 from "./AuthorizedSection.vue?vue&type=style&index=0&id=4a36a331&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a36a331",
  null
  
)

export default component.exports